module.exports = __webpack_public_path__ + "static/img/company.1219ee4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/company.png
// module id = NeCJ
// module chunks = 0